import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatBadgeModule } from '@angular/material/badge';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { PotentialDealsSmartComponent } from './potential-deals-smart/potential-deals-smart.component';
import { PotentialDealsTableComponent } from './potential-deals-table/potential-deals-table.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { FormlyMaterialModule } from '@ngx-formly/material';
import { FormlyModule } from '@ngx-formly/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AlertModule } from 'app/components/alert/alert.module';
import { LoanProductMatchModule } from './loan-product-match/loan-product-match.module';
import { ResignAppComponent } from './resign-app/resign-app.component';
import { RejectDealReasonsComponent } from './reject-deal-reasons/reject-deal-reasons.component';
import { MonthlyTotalsModule } from 'app/monthly-totals/monthly-totals.module';

@NgModule({
    declarations: [
        PotentialDealsSmartComponent,
        PotentialDealsTableComponent,
        RejectDealReasonsComponent,
        ResignAppComponent,
    ],
    imports: [
        AlertModule,
        CommonModule,
        FormlyMaterialModule,
        FormlyModule,
        FormsModule,
        LoanProductMatchModule,
        MatBadgeModule,
        MatButtonModule,
        MatCheckboxModule,
        MatDialogModule,
        MatIconModule,
        MatProgressSpinnerModule,
        MatSortModule,
        MatTableModule,
        MatTooltipModule,
        MatSelectModule,
        MatInputModule,
        MonthlyTotalsModule,
        ReactiveFormsModule,
    ],
    exports: [
        PotentialDealsSmartComponent,
        PotentialDealsTableComponent,
    ]
})
export class PotentialDealsModule { }
